import {useState} from 'react';
import {Modal} from 'antd';
import {BookStatusTag} from "./BookStatusTag";

export const BookSelectWidget = ({book, onBookChange, props}) => {
    const [modalOpen, setModalOpen] = useState(false);

    const onOpen = () => {
        setModalOpen(true);
    }

    const onOk = () => {
        setModalOpen(false);
        if (onBookChange) {
            onBookChange (book ? 0 : 1);
        }
    }

    const onCancel = () => {
        console.log(`cancel`)
        setModalOpen(false);
    }

    return <div>
        <Modal title={`Change Inventory Book Value`} open={modalOpen} onOk={onOk} onCancel={onCancel}>
            Changing the value will set book to <BookStatusTag book={book ? 0 : 1} />
        </Modal>
    <div onClick={onOpen} style={{cursor: 'pointer'}}>
        <BookStatusTag book={book} />
    </div>
    </div>
}